module.exports = __webpack_public_path__ + "img/img_hope01.745893d1.png";